import { useEffect, useRef } from "react";

export function useRaf(
    callback: (timeElapsed: number) => void,
    isActive: boolean
  ): void {
    const savedCallback = useRef<(timeElapsed: number) => void | null>(null);
    // Remember the latest function.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    useEffect(() => {
      let animationFrame: number | undefined;
      let startTime: number = Date.now();
  
      function tick() {
        const timeElapsed = Date.now() - startTime;
        startTime = Date.now();
        loop();
        savedCallback.current?.(timeElapsed);
      }
  
      function loop() {
        animationFrame = requestAnimationFrame(tick)
      }
  
      if (isActive) {
        startTime = Date.now();
        loop();
  
        return () => {
          if (animationFrame) {
            cancelAnimationFrame(animationFrame)
          }
        };
      } else {
        return () =>{};
      }
    }, [isActive]);
  }